import {getPaginationLinks} from "./template";

class LinkPager {
  constructor(paginationElement) {
    this.element = paginationElement;

    try {
      if (!this.element) {
        throw new Error("Не найдет элемент пагинации");
      }
    } catch (error) {
      console.log(error);
    }
  }

  getLastPage() {
    const linkElements = Array.from(this.element.querySelectorAll("a[data-page]"));
    const pages = linkElements.map((link) => {
      if (link.dataset.page !== "Дальше") {
        return +link.dataset.page;
      }
    });

    return Math.max(...pages);
  }

  getUpdatedPaginationElement(currentPage, pagesAmount, searchParams, perPage) {
    return getPaginationLinks(currentPage, pagesAmount, searchParams, perPage);
  }
}

export {LinkPager};
